export default __webpack_public_path__ + "static/media/bill.cacf7134.svg";